import { Form, Row, Col, Card, Breadcrumb, } from "@deere/ux.uxframe-react";
import { Fragment } from "react";
import { Link } from 'react-router-dom';
import {useOktaAuth} from "@okta/okta-react";

export default function useDocument() {

    //const [isLoading, setIsLoading] = useState(false);
    //setIsLoading(true);
    const {authState} = useOktaAuth();
    if (!authState.isAuthenticated) {
       // await authService.login();
        return;
    }

   /* const {authState} = useOktaAuth();
    if (!authState) {
        return;
    }*/

    return (
        <Fragment>
            <title>Documents</title>
            <Card style={{ margin: '2%' }}>
                <div style={{ marginTop: '2%', marginLeft: '2%' }}><Breadcrumb links={[{
                    title: "Home",
                    href: "/Viewlist"
                }, {
                    title: "Documents",
                }]} label="breadcrumbs" />
                    <Card.Body>
                        <Card.Title style={{ marginLeft: '1%' }}>Documents</Card.Title>
                        <Row style={{ marginTop: '4%' }}>
                            <Col xs={12} md={7}>

                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2%' }}>
                                    <Link to="../../Hot Part Recall Process Instructions.doc" target="_blank" download>PDC Parts Process Map</Link>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" style={{ marginLeft: '2%' }}>
                                    <Link to="../../Error occurred while processing vendor error doc.docx" target="_blank" download>Error Occured While Processing</Link>
                                </Form.Group>

                            </Col>

                        </Row>
                    </Card.Body></div>
            </Card>
        </Fragment>
    );
}